import { H2, IBaseBlockShowResource, RenderView, Section, SubmitButton, TextField, isSuccess } from "@dgs/core";
import { Form, Formik } from "formik";
import { FC, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import styled from "styled-components";
import { useRegion } from "../region/RegionProvider";
import { registrationFormService } from "../shared/api/registrationForms";
import { RegistrationFormPrivateShowResource, RegistrationFormResource } from "../shared/types/registrationForm";
import { RegistrationFormAvailablePage } from "./RegistrationFormAvailablePage";

const Header = styled(H2)`
	padding: ${({ theme }) => theme.spacing(5)} 0;
`;

const StyledSection = styled(Section)`
	display: grid;
	justify-content: center;
	align-items: center;
`;

const StyledForm = styled(Form)`
	display: grid;
`;

export const RegistrationFormCodePage: FC<{
	registrationForm: RegistrationFormPrivateShowResource;
	block: IBaseBlockShowResource | null;
}> = ({ registrationForm, block }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { regionId } = useRegion();
	const [verifiedRegistrationForm, setVerifiedRegistrationForm] = useState<RegistrationFormResource | null>(null);
	const onSubmit = useCallback(
		async ({ code }: { code: string }) => {
			const res = await registrationFormService.verifyCode(registrationForm.id, code);
			if (isSuccess(res)) {
				setVerifiedRegistrationForm(res.data.data);
				res.data.data.guest && sessionStorage.setItem("registrationToken", res.data.data.guest.id);
				navigate("../landing-page");
			}
		},
		[navigate, registrationForm.id],
	);
	const validate = useCallback(
		async ({ code }: { code: string }) => {
			if (!code) {
				return { code: t("Field is required") };
			}
		},
		[t],
	);

	if (verifiedRegistrationForm) {
		return <RegistrationFormAvailablePage registrationForm={verifiedRegistrationForm} />;
	}

	return (
		<>
			{block && <RenderView block={block} />}
			<StyledSection>
				<Formik initialValues={{ code: "" }} onSubmit={onSubmit} validate={validate}>
					<StyledForm>
						{!block && <Header>{t("Protected registration")}</Header>}
						<TextField name="code" label={t("Please type in your code")} />
						<SubmitButton disabled={!regionId}>{t("registration.submit")}</SubmitButton>
					</StyledForm>
				</Formik>
			</StyledSection>
		</>
	);
};
